var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 16.0002C7.05481 16.0002 4.66699 13.6123 4.66699 10.6668C4.66699 7.72131 7.05481 5.3335 10.0003 5.3335C12.9458 5.3335 15.3337 7.72131 15.3337 10.6668C15.3304 13.611 12.9445 15.9969 10.0003 16.0002ZM10.0003 6.66683C7.79119 6.66683 6.00033 8.45769 6.00033 10.6668C6.00033 12.876 7.79119 14.6668 10.0003 14.6668C12.2095 14.6668 14.0003 12.876 14.0003 10.6668C13.9978 8.45876 12.2084 6.6694 10.0003 6.66683ZM10.667 11.3335H9.33366V8.00016H10.667V11.3335ZM14.8623 7.13816L13.529 5.80483L14.4717 4.86216L15.805 6.1955L14.863 7.1375L14.8623 7.13816ZM12.0003 4.66683H8.00033V3.3335H12.0003V4.66683Z",
    fill: "#103680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.68b4413c9607da532c856bc8612c96fd.svg";
export { ForwardRef as ReactComponent };